// extracted by mini-css-extract-plugin
export default {"badge":"SectionBadge_badge__Sfgwy","light":"SectionBadge_light__AHC1O","icon":"SectionBadge_icon__bLnt-","label":"SectionBadge_label__duzmg","sm":"SectionBadge_sm__bcJdD"};